// 数据上报公共配置
import thinkingdata from "thinkingdata-browser";
import { DATA_ANALYTIC_URL } from "./constant";

export const DataAnalytic = (config: Record<string, unknown>) => {
  const defaultConfig = {
    appId: "",
    serverUrl: DATA_ANALYTIC_URL,
    showLog: false,
    autoTrack: {
      pageShow: true, //开启页面展示事件，事件名ta_page_show
      pageHide: true //开启页面隐藏事件，事件名ta_page_hide
    },
    zoneOffset: 8
  };
  config = Object.assign(defaultConfig, config);

  thinkingdata.init(config);

  const login = (id: number) => {
    thinkingdata.login(id);
  };

  // 设置公共属性上报
  const setSuperProperties = (properties: Record<string, unknown>) => {
    thinkingdata.setSuperProperties(properties);
  };

  const quick = (track: string) => {
    thinkingdata.quick(track);
  };

  const logout = () => {
    thinkingdata.logout();
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const track = (track: string, properties?: Record<string, any>) => {
    if (properties) {
      if (properties.event_duration) {
        properties["#duration"] = properties.event_duration;
      }
      if (!properties.page_url) {
        properties.page_url = window.location.href;
      }
    }
    thinkingdata.track(track, properties);
  };

  // 设置偏移时区静态公共属性
  setSuperProperties({
    timezone_offset: new Date().getTimezoneOffset() / -60
  });

  const timeEvent = (event: string) => {
    thinkingdata.timeEvent(event);
  };

  const clearSuperProperties = () => {
    thinkingdata.clearSuperProperties();
  };

  const unsetSuperProperty = (propertyName: string) => {
    thinkingdata.unsetSuperProperty(propertyName);
  };

  const userUniqAppend = (propertyName: Record<string, unknown>) => {
    thinkingdata.userUniqAppend(propertyName);
  };

  return {
    setSuperProperties,
    quick,
    logout,
    login,
    track,
    timeEvent,
    clearSuperProperties,
    unsetSuperProperty,
    userUniqAppend
  };
};
